import { render, staticRenderFns } from "./potion.vue?vue&type=template&id=3c4d0a53&scoped=true"
import script from "./potion.vue?vue&type=script&lang=ts"
export * from "./potion.vue?vue&type=script&lang=ts"
import style0 from "./potion.vue?vue&type=style&index=0&id=3c4d0a53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d0a53",
  null
  
)

export default component.exports